module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-2-Social-Static-Ad-w960.46a70981.webp";